<template>
	<div class="user-app">
		<div class="user">
			<div class="user-left">
				<dl>
					<dt>
						<img :src="userInfo.image" />
					</dt>
					<dd>
						<img src="/images/vip.png" v-if="user_vip == 1" />
						{{userInfo.nickname == null?userInfo.mobile:userInfo.nickname}}
					</dd>
					<router-link to="/user/photo" title="修改头像">[修改头像]</router-link>
				</dl>
				<ul>
					<li v-for="item in list" :key="item.id" :class="{active:item.url == $route.path}">
						<router-link :to="item.url">
							<img :src="item.src" />
							{{item.text}}
						</router-link>
					</li>
				</ul>
			</div>
			<div class="user-right">
				<router-view></router-view>
			</div>
			<div class="clear"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "user-app",
		data() {
			return {
				list: [
					// {
					// 	src: "/images/per_1.png",
					// 	text: "基本资料",
					// 	url: "/user",
					// },
					{
						src: "/images/per_2.png",
						text: "修改密码",
						url: "/user/password",
					},
					{
						src: "/images/per_4.png",
						text: "错题巩固",
						url: "/user/wrong",
					},
					{
						src: "/images/an_9.png",
						text: "我的收藏",
						url: "/user/collect",
					},
					{
						src: "/images/per_5.png",
						text: "我的笔记",
						url: "/user/note",
					},
				],
				userInfo: "",
			};
		},
		methods: {
			getUserInfo(uid) {
				// var param = { uid: uid };
				this.$api.getUserInfo().then((res) => {
					this.userInfo = res.data.user;
					localStorage.setItem('userInfo',JSON.stringify(this.userInfo))
				});
			},
		},
		created() {
			this.getUserInfo(this.user_id);
		},
	};
</script>

<style scoped>
	/*个人中心*/
	.user-left {
		width: 300px;
		background: #fff;
		float: left;
		text-align: center;
		min-height: 700px;
	}
	.user-left dl {
		width: 200px;
		margin: 30px auto auto auto;
	}
	.user-left dt {
		width: 150px;
		height: 150px;
		background: #f5f5f5;
		border-radius: 6px;
		line-height: 150px;
		margin: 0 auto;
	}
	.user-left dt img {
		width: 130px;
		height: 130px;
		border-radius: 6px;
	}
	.user-left dd {
		font-size: 16px;
		color: #333;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 10px 0;
	}
	.user-left dd img {
		height: 20px;
		margin: -2px 5px 0 0;
	}
	.user-left dl a {
		color: #999;
	}
	.user-left dl a:hover {
		color:#e60012;;
		text-decoration: underline;
	}

	.user-left ul {
		margin: 30px auto;
		border-top: 1px solid #f3f3f3;
	}
	.user-left ul li a {
		display: block;
		height: 60px;
		border-bottom: 1px solid #f3f3f3;
		line-height: 60px;
		font-size: 16px;
		position: relative;
	}
	.user-left ul li a img {
		position: relative;
		top: -2px;
	}
	.user-left ul li a:hover:before {
		content: "";
		display: block;
		width: 4px;
		height: 100%;
		background:#e60012;
		position: absolute;
		left: 0;
	}
	.user-left ul li a:hover {
		color:#e60012;
		background: #f5f5f5;
	}
	.user-left ul .active a {
		color:#e60012;
		background: #f5f5f5;
	}
	.user-left ul .active a:before {
		content: "";
		display: block;
		width: 4px;
		height: 100%;
		background:#e60012;
		position: absolute;
		left: 0;
	}
	.user-right {
		float: right;
		width: 870px;
		background-color: #fff;
		min-height: 700px;
	}
</style>
